import React, { useState } from 'react';
import styled from 'styled-components';
import Image from './Image';
import useModal from '../hooks/useModal';
import NOOP from '../utils/NOOPUtils';
const OvalEmptyImage = require('../assets/images/carousel-dot-empty.svg');
const OvalEmptyImageAltText = 'carouselDotEmpty';
const OvalFilledImage = require('../assets/images/carousel-dot-filled.svg');
const OvalFilledImageAltText = 'carouselDotFilled';
const NavigationRightCircleArrow = require('../assets/images/nav-arrow-right.svg');
const NavigationRightCircleArrowAltText = 'navigationRightArrow';
const NavigationLeftCircleArrowAltText = 'navigationLeftArrow';
const NavigationCircleArrowWidth = '30px';
const NavigationCircleArrowHeight = '30px';
const ModalWizard = ({ sections, isModalVisible = false, enableModalClosing = true, onModalClose = NOOP }) => {
    const [position, setPosition] = useState(0);
    const { isVisible, isCloseModalEnabled, closeModal, enableCloseModal } = useModal(isModalVisible, enableModalClosing, onModalClose);
    // if no sections, or modal is set to not visible, render nothing
    if (!sections.length || !isVisible) {
        return React.createElement(React.Fragment, null);
    }
    // if closing modal has been disabled and we are at the last section, enable closing
    if (!isCloseModalEnabled && (position == (sections.length - 1))) {
        enableCloseModal();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalWizardOverlay, { onClick: (event) => closeModal() }),
        React.createElement(ModalWizardWrapper, null,
            React.createElement(ModalWizardSectionsWrapper, null, sections.map((section, index) => {
                return React.createElement(ModalWizardSection, { key: index, active: (position == index), section: section });
            })),
            React.createElement(ModalWizardNavigationContainer, null,
                React.createElement(ModalWizardNavigationWrapper, null,
                    React.createElement(ModalWizardNavigationLeftArrow, { onClick: () => setPosition(position - 1), alt: NavigationLeftCircleArrowAltText, height: NavigationCircleArrowHeight, width: NavigationCircleArrowWidth, src: NavigationRightCircleArrow, styleContainer: false, hidden: (position == 0) }),
                    React.createElement(ModalWizardNavigationOvalSelectionWrapper, null, sections.map((section, index) => (React.createElement(ModalWizardNavigationOvalSelection, { key: index, onClick: () => setPosition(index), alt: (position == index) ? OvalFilledImageAltText : OvalEmptyImageAltText, src: (position == index) ? OvalFilledImage : OvalEmptyImage, styleContainer: false })))),
                    React.createElement(ModalWizardNavigationRightArrow, { onClick: () => setPosition(position + 1), alt: NavigationRightCircleArrowAltText, height: NavigationCircleArrowHeight, width: NavigationCircleArrowWidth, src: NavigationRightCircleArrow, styleContainer: false, hidden: (position == (sections.length - 1)) }))))));
};
const ModalWizardSection = ({ active, section }) => {
    return (React.createElement(React.Fragment, null, active &&
        section));
};
const ModalWizardOverlay = styled.div `

    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1000;
    
    background: black;
    opacity: .5;
`;
const ModalWizardWrapper = styled.div `
    
    display:flex;
    
    flex-direction: column;
    left: 50%;
    position: absolute;
    top: 50%
    transform: translate( -50%, -50%);
    z-index: 1001;
    
    background: white;
    border-radius: 12px;
`;
const ModalWizardSectionsWrapper = styled.div `
    
    flex: 1;
`;
const ModalWizardNavigationContainer = styled.div `
    width: 100%;
    position: absolute;
    bottom: 0;
`;
const ModalWizardNavigationWrapper = styled.div `
    
    display:flex;
    
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    padding: 26px 30px;
`;
const ModalWizardNavigationLeftArrow = styled(({ hidden, ...rest }) => React.createElement(Image, { ...rest })) `

    visibility: ${props => props.hidden && 'hidden'};
    
    height: 30px;
    transform: scaleX(-1);
    width: 30px;
    
    cursor: pointer;
`;
const ModalWizardNavigationRightArrow = styled(({ hidden, ...rest }) => React.createElement(Image, { ...rest })) `

    visibility: ${props => props.hidden && 'hidden'};
    
    height: 30px;
    width: 30px;
    
    cursor: pointer;
`;
const ModalWizardNavigationOvalSelectionWrapper = styled.div `
    
    display:flex;
    
    flex-direction: row;
`;
const ModalWizardNavigationOvalSelection = styled(Image) `
    
    margin: 0 5px;
    height: 10px;
    width: 10px;
    
    cursor: pointer;
`;
export default ModalWizard;
//# sourceMappingURL=ModalWizard.js.map